module.exports = global["application_chart_diff"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./diff.ts");